import React, { useState, useEffect } from 'react'; 
import { Link, useNavigate } from 'react-router-dom'; 
import './HomeComponent.css'; 

function HomeComponent() { 
    return (
        <div>
            <h1>home component</h1>
        </div>
    );
}

export default HomeComponent;
